// Assets
import heroImage from '../../assets/img/hero/home-hero-video-placeholder.jpg';

// Data
import { getSeason } from '../episodes';

export default {
  hasTransparentNav: true,
  hasRebateCallout: true,
  metadata: {
    title: 'Dinner Spinner | Oklahoma Natural Gas',
    description:
      'Professional chefs from Tulsa and Oklahoma City make their favorite dish, two ways, in Dinner Spinner. Which one would you make at home?',
    type: 'website'
  },
  title: 'Home Page',
  className: 'home',
  hero: {
    image: heroImage,
    video: `${process.env.PUBLIC_URL}/videos/hero-home.mov`,
    title: 'What’s for Dinner?',
    cta: 'View Recipes',
    link: '/recipes'
  },
  heading:
    'Our chefs were tasked with using special ingredients to come up with quick and affordable meals. Give one a spin tonight!',
  seasons: [{ title: '', episodes: getSeason(1) }],
  pageLinks: [
    {
      to: '/recipes',
      children: 'View Recipes'
    },
    {
      to: '/cooking-with-gas',
      children: 'Cooking with Gas'
    }
  ]
};
